export default {
  name: 'menu.dashboard',
  path: '/dashboard',
  meta: {
    keepAlive: false,
    cacheName: 'Dashboard',
  },
  component: () => import('../views/index/dashboard/Dashboard.vue'),
};
